<script>
export default {
  metaInfo () {
    return {
      title: 'InheriNext'
    }
  }
}
</script>
